module.exports = __webpack_public_path__ + "static/media/back-to-top.9806c346.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/back-to-top.svg
// module id = 5864
// module chunks = 0